import React, { Fragment } from 'react';
import { H4, H5, LI, P, UL } from '../../../AbstractElements';
import { Card, CardBody, Col, Label, Input, Media } from 'reactstrap';
import { FreeShipping, FreeShippingWorldWide, OnlineService, ServiceTime } from '../../../Constant';
import { FiClock, FiTruck } from 'react-icons/fi';
import { BrandShippingData } from '../../../Data/Ecommerce/ProductPage';

const BrandShipping = () => {
  return (
    <Fragment>
      <Col xl='2' md='6' className='box-col-5 xl-50 proorder-lg-1'>
        <Card>
          <CardBody>
            <div className='filter-block'>
              <H4>{'Brand'}</H4>
              <UL className='simple-list'>
                {BrandShippingData.map((item, i) => (
                  <LI key={i}>
                    <div className='form-check'>
                      <Input className='form-check-input' id={item} type='checkbox' value='' />
                      <Label className='form-check-label' htmlFor={item}>
                        {item}
                      </Label>
                    </div>
                  </LI>
                ))}
              </UL>
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className='collection-filter-block'>
              <UL className='simple-list pro-services'>
                <LI>
                  <Media className='d-flex'>
                    <FiTruck className='w-h-24' />
                    <div className='flex-grow-1'>
                      <H5>{FreeShipping}</H5>
                      <P>{FreeShippingWorldWide}</P>
                    </div>
                  </Media>
                </LI>
                <LI>
                  <Media className='d-flex'>
                    <FiClock className='w-h-24' />
                    <div className='flex-grow-1'>
                      <H5>{ServiceTime}</H5>
                      <P>{OnlineService}</P>
                    </div>
                  </Media>
                </LI>
              </UL>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default BrandShipping;
